const digest = '25b749677d9cd7358aa847d4388931a14450026c1ed33e521ccb436a7af20ea6';
const css = `._pageLevelNotification_1fz2g_1>div:last-child{min-width:0}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'pageLevelNotification': '_pageLevelNotification_1fz2g_1' };
export const pageLevelNotification = '_pageLevelNotification_1fz2g_1';
export { css, digest };